export class Issues_ListModel {
    IssuelistAPI: any;
    getissuelistbyIdAPI: string;

}
